import {downloadFileFromResponse, putAll, showBeError, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {getRequestedTableCsvExportParams, simpleTableSelector} from 'utils/tables';

import {ExportMilkabilityReportsAction, milkabilityAction} from '../action';

function* execute(_: ExportMilkabilityReportsAction): SagaIterator {
    yield* put(milkabilityAction.setLoading('exportingMilkabilityOverview', true));

    const tableState = opt(yield* select(simpleTableSelector.tableState('milkabilityOverview')))
        .orCrash('no tableState');
    const {sort, fieldParams} = getRequestedTableCsvExportParams(tableState);

    const response = yield* call(Api.exportMilkabilityReports, fieldParams, {sort});

    if (response.isSuccess) {
        yield* call(downloadFileFromResponse, response);
    } else {
        yield putAll(showBeError(response, t('common')('downloadCsv')));
    }

    yield* put(milkabilityAction.setLoading('exportingMilkabilityOverview', false));
}

/** Watches milkability export requests and downloads the filtered overview CSV. */
export function* exportMilkabilityReportsSaga(): SagaIterator {
    yield takeLatestF('milkability/EXPORT_MILKABILITY_REPORTS', execute);
}
